var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _rect4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlucometr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 70,
    viewBox: "0 0 243 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 20C0.755859 8.9543 9.71016 0 20.7559 0H215.756C230.668 0 242.756 12.0883 242.756 27V43C242.756 57.9117 230.668 70 215.756 70H20.7559C9.71017 70 0.755859 61.0457 0.755859 50V20Z",
    fill: "url(#paint0_linear_618_56438)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25586,
    y: 5.5,
    width: 28,
    height: 59,
    rx: 13.5,
    fill: "url(#paint1_radial_618_56438)",
    stroke: "#312A24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25586,
    y: 7.5,
    width: 25,
    height: 55,
    rx: 12.5,
    fill: "url(#paint2_radial_618_56438)",
    stroke: "#585858"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75586,
    y: 11,
    width: 21,
    height: 48,
    rx: 10.5,
    fill: "url(#paint3_radial_618_56438)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2559 16C30.2559 13.7909 32.0467 12 34.2559 12H221.756C228.383 12 233.756 17.3726 233.756 24V46C233.756 52.6274 228.383 58 221.756 58H34.2559C32.0467 58 30.2559 56.2091 30.2559 54V16Z",
    fill: "#1A151B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 5.00024C16.7559 5.00024 208.256 4.99986 217.756 5.00004C227.256 5.00022 233.256 13 233.256 21C229.256 13 217.756 13 217.756 13H28.2559C26.7559 9.00024 21.7559 5.50024 16.7559 5.00024Z",
    fill: "url(#paint4_linear_618_56438)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7559 64.9998C17.7559 64.9998 209.256 65.0001 218.756 65C228.256 64.9998 234.256 57 234.256 49C230.256 57 218.756 57 218.756 57H29.2559C27.7559 60.9998 23.2559 63.5 17.7559 64.9998Z",
    fill: "url(#paint5_linear_618_56438)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7559,
    y: 18,
    width: 136,
    height: 35,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7559 43.5L64.7559 39L62.2559 36V46L64.7559 43.5L59.7559 39M79.7559 27L81.7559 29.5L85.2559 25",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.756,
    cy: 35,
    r: 19.5,
    fill: "url(#paint6_linear_618_56438)",
    stroke: "#8A898E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.756,
    cy: 35,
    r: 12,
    fill: "url(#paint7_angular_618_56438)",
    stroke: "#150B0A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7559 46.5H109.756V33H101.756V22H111.256M116.256 22H127.756V33H117.756V46.5H129.256M113.756 46V48",
    stroke: "#D0CED3",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.756 20H204.756L207.756 16.5L210.756 20Z",
    fill: "#D0CED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.256 50H205.256L208.256 53L211.256 50Z",
    fill: "#D0CED3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.756 23.5V21H136.256V23.5M140.756 23.5V21H137.756V23.5M146.756 23.5V19.5M148.256 24.5L150.756 18M155.256 19.5V24H157.756M135.756 28V31M135.756 32.5V35.5M138.256 32.5V35.5M140.756 28V31M145.756 32.5V35.5M153.756 32.5V35.5M153.756 28V31M148.756 28V31M145.756 27.5H148.256M145.756 31.5H148.256M146.256 36H148.756M151.256 36H153.756M151.256 31.5H153.756M151.256 27.5H153.756M138.256 27.5H140.756M138.256 31.5H140.756M138.256 36H140.756M134.256 39.5H136.756M134.256 43.5H136.756M134.256 47.5H136.756M137.256 40V43M133.256 44V47M141.756 44V47M142.756 39.5V42.5M145.756 39.5L143.756 47.5M151.256 39.5V42.5M151.256 44.5V47.5M153.756 44V47M156.756 44V47M153.756 39.5V42.5M156.756 39.5V42.5M161.256 39.5L158.756 47.5M165.756 39.5V42.5M165.756 44.5V47.5M171.256 44V47M168.256 39.5V42.5M154.256 38.7878H156.756M154.256 47.5H156.756M168.756 39H171.256M168.756 43.5H171.256M168.756 47.5H171.256M176.756 33.5H174.756L176.256 40.5H177.256M176.756 33.5L177.256 40.5M176.756 33.5H179.756M177.256 40.5H178.506M178.506 40.5H179.756L181.756 33.5H179.756M178.506 40.5L179.756 33.5M142.756 23.5V21H144.756V23.5H142.756Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_618_56438",
    x1: 121.756,
    y1: 0,
    x2: 121.756,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#191411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423E3F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_618_56438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2559 35) rotate(90) scale(30 17.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_618_56438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7559 35) rotate(90) scale(28 15.4375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_618_56438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2559 35) rotate(90) scale(30.5 19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517857,
    stopColor: "#05A84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97541,
    stopColor: "#081607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_618_56438",
    x1: 125.006,
    y1: 5,
    x2: 124.756,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7AEA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AEA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_618_56438",
    x1: 126.006,
    y1: 65,
    x2: 126.006,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77686D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_618_56438",
    x1: 207.756,
    y1: 15,
    x2: 207.756,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A29C9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_618_56438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.756 35) rotate(-35.5377) scale(12.9035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0966175,
    stopColor: "#686367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356298,
    stopColor: "#A29C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607859,
    stopColor: "#686367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853434,
    stopColor: "#A29C9C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucometr);
export default __webpack_public_path__ + "static/media/glucometr.7a90d62b4eb40e57a4f5913308a5aea6.svg";
export { ForwardRef as ReactComponent };